import React, { createRef } from 'react';
import ImportNotification from './ImportNotification';
import { connect } from 'react-redux';
import evemts from 'utils/evemts';
import http from 'utils/http';
import cookies from 'utils/cookies';
import { cloneDeep } from 'lodash';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf
} from '@react-pdf/renderer';
import moment from 'moment';
import { getLocatDate } from 'utils/converter';
import environment from '../../../custom/environments';
import { DateFormat } from 'custom/constants';
// import { clearedCustomsCodes } from '../../../custom/constants';

const timezone = cookies.get('timezone') || null;

class ImportNotificationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        awbType: 'total',
        customsCleared: true,
        noCustomsClearance: true,
        bouncedNotifications: false,
      },
      modal: false,
      search: '',
      searchFilters: {
        start_date: null,
        end_date: null,
        noCustomsClearance: false,
        airline: false
      },
      anchorEl: null,
      additionalServices: {},
      importAwbs: [],
      filteredImportAwbs: [],
      modalData: false,
      houseAwbFields: {},
      houseAwbErrors: {},
      services: [],
      scale: 1.0,
      serviceFields: {},
      serviceErrors: {},
      activeAWB: null,
      docList: [],
      activeDoc: null,
      viewPreview: '',
      docErrors: {},
      nfdProcessing: false,
      addDocType: 'AWB',
      attachTo: 'OTHER',
      docFields: {},
      columnWidth: {},
      consignees: [],
      selectedConsignee: null,
      consigneeFields: {
        name: '',
        address: '',
        address2: '',
        state: '',
        city: '',
        zip: '',
        email: '',
        phone_code: '+1',
        phone_number: '',
        mails: [],
      },
      consigneeFieldsErrors: {},
      consigneeOperation: '',
      consigneeSearch: '',
      consigneeAddress: '',
      consigneRow: {},
      lastConsigneeRequest: 0,
      collapseViewer: [],
      popover: false,
      popoverAnchorEl: null,
      popoverData: false,
      editHouseAwb: false,
      cron: '',
      cron_period: '',
      cron_code: '',
      customStatusCodes: [],
      airlineList: [],
      customStatus: [],
      scraper: [],
    };
    this.eventSource = null;
    this.columnRef = {
      id: createRef(),
      radio_btn: createRef(),
      awb_no: createRef(),
      pcs: createRef(),
      wgt: createRef(),
      org_dest: createRef(),
      commodity: createRef(),
      storage_start: createRef(),
      fee: createRef(),
      add_icon: createRef(),
      consignee: createRef(),
      action: createRef(),
    };
  }

  componentDidMount() {
    this.fetchHolidays();
    this.fetchTimings();
    this.updateColumnWidth();
    this.fetchServices();
    this.fetchCustomStatusRecheckInterval();
    this.fetchCustomStatusCodes();
    this.fetchAirlines();
    this.fetchCustomStatus();
    this.fetchScraper();
    if (this.props?.flightTab) {
      if (this.props.flight) {
        this.fetchImportNotification(this.props.flight.id);
        this.handleEvent(this.props.flight.id);
      }
    } else {
      this.handleEvent();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props?.flightTab && prevProps.flight?.id !== this.props.flight?.id && this.props.flight?.id) {
      this.eventSource && this.eventSource.close();
      this.handleEvent(this.props.flight.id);
      this.fetchImportNotification(this.props.flight.id);
    }

    // Object.keys(this.columnRef).forEach((key) => {
    //   if (
    //     this.columnRef[key].current &&
    //     prevState.columnWidth[key] !== this.columnRef[key].current.offsetWidth
    //   ) {
    //     this.updateColumnWidth();
    //   }
    // });

  }

  componentWillUnmount() {
    this.eventSource && this.eventSource.close();
  }

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        this.setState({ airlineList: response.data.data });
      });
  };

  fetchHolidays = () => {
    http.get('settings?key=holidays').then(({ data }) => {
      if (data.data) {
        let holidays = data.data.find((item) => item.key === 'holidays');
        if (holidays) {
          cookies.set('holidays', holidays?.value || []);
        }
      }
    });
  };

  fetchCustomStatus = () => {
    http.get('/airline_config?type=' + 'custom_status')
      .then((response) => {
        // handle success
        this.setState({ customStatus: response.data.data }, () => {
          this.fetchAirlines();
        });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching customs status:', error);
      });
  };

  fetchScraper = () => {
    http.get('/airline_config?type=' + 'scraper')
      .then((response) => {
        // handle success
        this.setState({ scraper: response.data.data }, () => {
          this.fetchAirlines();
        });
      })
      .catch((error) => {
        // handle error
        console.error('Error fetching scraper:', error);
      });
  };

  fetchCustomStatusRecheckInterval = () => {
    http.get('/settings?key=custom_status_check_interval').then(({ data }) => {
      if (data.data) {
        let cron = data.data?.find((item) => item.key === 'custom_status_check_interval');
        if (cron) {
          this.setState({
            cron: cron?.value?.time || '',
            cron_period: cron?.value?.period || '',
            cron_code: cron?.value?.code || ''
          });
        }
      }
    });
  };

  fetchTimings = () => {
    http.get('station_timing', { headers: { hideloader: true } }).then(({ data }) => {
      if (data.data) {
        cookies.set('station_timing', data.data || {});
      }
    });
  };

  fetchImportNotification = (id = null) => {
    let search = this.state.search && this.state.search?.replaceAll(' ', '') !== '' ? '&search=' + this.state.search : '';
    const { start_date, end_date } = this.state.searchFilters;
    let dateParams = '';
    if (start_date && end_date) {
      dateParams += '&start_date=' + start_date;
      dateParams += '&end_date=' + end_date;
    }
    if (!this.props.flightTab && search === '' && dateParams === '') {
      this.setState({
        importAwbs: [],
        activeAWB: null,
        docList: [],
        activeDoc: null,
        viewPreview: '',
      }, () => {
        this.filterImportNotification();
      });
      return;
    }
    http.get('import_awb?flight_id=' + id + search + dateParams).then(({ data }) => {
      if (data.data.length > 0) {
        this.setState({
          importAwbs: data.data,
          activeAWB: data.data[0]
        }, () => {
          this.filterImportNotification();
        });
      } else {
        this.setState({
          importAwbs: [],
          activeAWB: null,
          docList: [],
          activeDoc: null,
          viewPreview: '',
        }, () => {
          this.filterImportNotification();
        });
      }
    });
  };

  filterImportNotification = () => {
    let importAwbs = this.state.importAwbs;
    const awbType = this.state.filter.awbType;
    if (awbType === 'transit') {
      importAwbs = importAwbs.filter((awb) => {
        const dest = awb.flight_awbs?.[0]?.dest;
        return dest !== cookies.get('station_code');
      });
    }
    if (awbType === 'local') {
      importAwbs = importAwbs.filter((awb) => {
        const dest = awb.flight_awbs?.[0]?.dest;
        return dest === cookies.get('station_code');
      });
    }
    if (awbType === 'total') {
      importAwbs = importAwbs.filter((awb) => {
        return awb;
      });
    }
    //Filter Bounced Notifications
    if (this.state.filter.bouncedNotifications) {
      importAwbs = importAwbs.filter((awb) => {
        return awb.notifications?.filter((notification) => notification.mail.filter((mail) => mail.status !== 'pending' && mail.status !== 'delivered')?.length > 0)?.length > 0;
      });
    }
    // Check both filter.noCustomsClearance (flightTab) and searchFilters.noCustomsClearance (non-flightTab)
    if (this.state.filter.customsCleared || this.state.filter.noCustomsClearance) {
      importAwbs = importAwbs.filter((awb) => {
        const customStatusList = awb.custom_status?.status || [];
        const houseCustomStatusList = awb.custom_status?.house_status || [];
        // Check only the latest (last) status code
        const latestStatus = customStatusList[customStatusList.length - 1];
        let hasCleared = latestStatus && this.state.customStatusCodes?.marked_as_cleared?.includes(latestStatus?.dispositionCode);
        if(!hasCleared && houseCustomStatusList.length > 0) {
          houseCustomStatusList.forEach((houseStatus) => {
            const latestHouseStatus = houseStatus?.dispositionMsg?.[houseStatus.dispositionMsg.length - 1];
            if (latestHouseStatus && this.state.customStatusCodes?.marked_as_cleared?.includes(latestHouseStatus?.dispositionCode)) {
              hasCleared = true;
            }
          });
        }
        if (this.state.filter.noCustomsClearance === this.state.filter.customsCleared) {
          // If both are selected or both are not selected, do not filter by customs status
          return true;
        }
        if (this.state.filter.customsCleared) {
          // Return only AWBs that have a cleared status
          return hasCleared;
        }
        else if (this.state.filter.noCustomsClearance) {
          // Return only AWBs that do NOT have a cleared status
          return !hasCleared;
        }
        else {
          // If none are selected, do not filter by customs status
          return true;
        }
      });
    }
    if (this.state.filter.awb_no) {
      importAwbs = importAwbs.filter((awb) => {
        const awb_no = awb.flight_awbs?.[0]?.awb_no;
        return awb_no === this.state.filter.awb_no || awb_no.includes(this.state.filter.awb_no);
      });
    }
    if (this.state.searchFilters.airline) {
      importAwbs = importAwbs.filter((awb) => {
        const airline = awb.flight.airline?.code;
        return airline === this.state.searchFilters.airline;
      });
    }
    this.setState({ filteredImportAwbs: importAwbs }, () => {
      this.fetchDocs(importAwbs[0]);
    });
  };

  //get awbdata and update or add to list.
  getSingleImportNotification = (id) => {
    return http.get('import_awb/' + id).then(({ data }) => {
      const newRecord = data.data && data.data.length > 0 ? data.data[0] : null;
      return new Promise((resolve) => {
        this.setState((prevState) => {
          // Create new copy of importAwbs array
          let importAwbs = [...prevState.importAwbs];
          const existingIndex = importAwbs.findIndex((awb) => awb.id === newRecord.id);

          if (existingIndex !== -1) {
            importAwbs = importAwbs.map((awb, index) =>
              index === existingIndex ? {
                ...awb,
                ...newRecord,
                consignee: {
                  ...awb.consignee,
                  ...newRecord.consignee
                }
              } : awb
            );
          }
          // else {
          //   importAwbs.push(newRecord);
          // }

          // Update activeAWB if it matches
          let activeAWB = prevState.activeAWB;
          if (activeAWB?.id === newRecord.id) {
            activeAWB = {
              ...activeAWB,
              ...newRecord,
              consignee: {
                ...activeAWB.consignee,
                ...newRecord.consignee
              }
            };
          }

          return {
            importAwbs,
            activeAWB,
            filteredImportAwbs: importAwbs
          };
        }, resolve);
      });
    });
  };

  handleEvent = (id = null) => {
    this.eventSource = evemts('import', id);
    this.eventSource.onmessage = (e) => {
      const msg = JSON.parse(e.data);
      if (msg.action === 'add' && id) {
        this.fetchImportNotification(id);
      }
      if (msg.action === 'update' && !msg.data.house_awbId) {
        this.setState((prevState) => {
          const index = prevState.importAwbs.findIndex((awb) => awb.id === msg.data.id);
          if (index === -1) {
            return null;
          }

          const importAwbs = [...prevState.importAwbs];
          importAwbs[index] = {
            ...importAwbs[index],
            ...msg.data
          };

          const nextState = { importAwbs };
          if (prevState.modalData?.id === msg.data.id) {
            nextState.modalData = importAwbs[index];
          }
          return nextState;
        }, () => {
          this.filterImportNotification();
        });
      }
      if (msg.action === 'update' && msg.data.house_awbId) {
        this.setState((prevState) => {
          const index = prevState.importAwbs.findIndex((awb) => awb.id === msg.data.house_awbId);
          if (index === -1) {
            return null;
          }

          const importAwbs = [...prevState.importAwbs];
          const house_awbs = [...(importAwbs[index].house_awbs || [])];
          const houseIndex = house_awbs.findIndex((house) => house.id === msg.data.id);

          if (houseIndex === -1) {
            house_awbs.push(msg.data);
          } else {
            house_awbs[houseIndex] = {
              ...house_awbs[houseIndex],
              ...msg.data
            };
          }

          importAwbs[index] = {
            ...importAwbs[index],
            house_awbs
          };

          const nextState = { importAwbs };
          if (prevState.modalData?.id === msg.data.id || prevState.modalData?.id === msg.data.house_awbId) {
            nextState.modalData = importAwbs[index];
          }
          return nextState;
        }, () => {
          this.filterImportNotification();
        });
      }

      if (msg.action === 'delete') {
        this.setState((prevState) => ({ importAwbs: prevState.importAwbs.filter((awb) => awb.id !== msg.data.id) }), () => {
          this.filterImportNotification();
        });
      }


      if (msg.action === 'house_awb') {
        this.setState((prevState) => {
          const index = prevState.importAwbs.findIndex((awb) => awb.id === msg.data.id);
          if (index === -1) {
            return null;
          }

          const importAwbs = [...prevState.importAwbs];
          importAwbs[index] = {
            ...importAwbs[index],
            house_awbs: msg.data?.house_awbs || []
          };

          const nextState = { importAwbs };
          if (prevState.modalData?.id === msg.data.id) {
            nextState.modalData = importAwbs[index];
          }
          return nextState;
        }, () => {
          this.filterImportNotification();
        });
      }
      if (msg.action === 'notification') {
        let updatedAwb = null;
        this.setState((prevState) => {
          const index = prevState.importAwbs.findIndex((awb) => awb.id === msg.data.import_awbId);
          if (index === -1) {
            return null;
          }

          const importAwbs = [...prevState.importAwbs];
          importAwbs[index] = {
            ...importAwbs[index],
            notifications: [
              msg.data,
              ...(importAwbs[index].notifications || []),
            ]
          };
          updatedAwb = importAwbs[index];
          return { importAwbs };
        }, () => {
          this.filterImportNotification();
          if (this.state.activeAWB?.id === updatedAwb?.id) {
            this.fetchDocs(updatedAwb);
          }
        });
      }
      if (msg.action === 'assign_consignee') {
        this.getSingleImportNotification(msg?.data?.parentAwbid || msg.data.id);
      }
      if (msg.action === 'add_doc') {
        let activeAWB = this.state.activeAWB;
        if (parseInt(activeAWB?.id) === parseInt(msg.data.id)) {
          this.fetchDocs(activeAWB);
        }
      }
      if (msg.action === 'add_awb_dock') {
        let activeAWB = this.state.activeAWB;
        this.getSingleImportNotification(msg.data.id)
          .then(() => {
            if (parseInt(activeAWB?.id) === parseInt(msg.data.id)) {
              this.fetchDocs(this.state.activeAWB);
            }
          });
      }
    };
  };


  handleOpen = (modal, anchorEl = null, modalData = false) => {
    this.setState({
      modal,
      anchorEl,
      modalData
    });
  };
  handlePopoverOpen = (popover, popoverAnchorEl = null, popoverData = false) => {
    this.setState({
      popover,
      popoverAnchorEl,
      popoverData
    });
  };

  handlePopoverClose = () => {
    this.setState({
      popover: false,
      popoverAnchorEl: null,
      popoverData: false,
    });
  };


  handleClose = () => {
    this.setState({
      modal: false,
      anchorEl: null,
      modalData: false,
      docFields: { file: '' },
      serviceFields: {},
      serviceErrors: {},
      //clear modal data
      consigneeOperation: '',
      consigneeSearch: '',
      consigneeAddress: '',
      consignees: [],
      selectedConsignee: null,
      consigneRow: {},
      consigneeFields: {
        name: '',
        address: '',
        address2: '',
        state: '',
        city: '',
        zip: '',
        email: '',
        phone: '',
        mails: [],
      },
      editHouseAwb: false,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    let data = {};
    if (name == 'id') {
      let service = this.state.services.find((service) => service.id == value);
      if (service) {
        let existing = this.state.modalData?.fee?.find((fee) => fee.id == value);
        if (existing) {
          data = { add_info_value: existing.add_info_value };
          service.value = service.value.map((v, index) => {
            let existingValue = existing.value?.[index];
            if (existingValue) {
              return {
                ...existingValue,
                ...v,
              };
            }
            return v;
          });
        }
        this.setState(() => ({
          serviceFields: {
            ...service,
            ...data,
          }
        }));
      }
    } else {
      this.setState((prev) => ({
        serviceFields: {
          ...(prev.serviceFields),
          [name]: value,
          ...data
        }
      }));
    }
  };

  handleChanegOperation = (index, e) => {
    const { name, value } = e.target;
    let serviceFields = { ...this.state.serviceFields };
    if (serviceFields.value?.[index]) {
      serviceFields.value[index] = {
        ...serviceFields.value[index],
        [name]: value
      };
    }
    this.setState({ serviceFields });
  };

  validateService = () => {
    let errors = {};
    let isValid = true;
    if (!this.state.serviceFields.id) {
      errors.id = true;
      isValid = false;
    }
    this.state.serviceFields.value?.forEach((value, index) => {
      if (value.unit == 'number' && !value.unit_value) {
        errors.value = errors.value || [];
        errors.value[index] = {
          ...errors.value[index],
          unit_value: true
        };
        isValid = false;
      }
      if (value.unit == 'kg' && !value.cost_per_unit) {
        errors.value = errors.value || [];
        errors.value[index] = {
          ...errors.value[index],
          cost_per_unit: true
        };
        isValid = false;
      }
    });
    this.setState({ serviceErrors: errors });
    return isValid;
  };


  onSubmitService = () => {
    if (!this.validateService()) {
      return;
    }
    http.post('import_awb/service/' + this.state.modalData.id, { fee: this.state.serviceFields });
  };

  onDeleteService = (fee) => {
    http.delete('import_awb/service/' + this.state.modalData.id + '/' + fee.id);
  };

  fetchServices = () => {
    http.get('additional_services').then((res) => {
      if (res.data) {
        this.setState({ services: res.data?.data || [] });
      }
    });
  };

  zoomIn = () => {
    this.setState((prevState) => ({ scale: prevState.scale + 0.2 }));
  };

  zoomOut = () => {
    this.setState((prevState) => ({ scale: Math.max(0.5, prevState.scale - 0.2) }));
  };

  partNotification = (id, next) => {
    http.put(`import_awb/${id}`, { next }).then(() => {
      this.handleClose();
    });
  };

  handleDeleteConsignee = (id) => {
    http.put(`assign_consingnee/${id}`, { consigneeId: null }).then(() => {
      // success
    });
  };


  onChangeHouseAwb = (e) => {
    let { name, value } = e.target;
    let fields = {};
    if (name === 'o_d') {
      if (value.length > 3) {
        let inputValue = value.replace(/-/g, '');
        value = inputValue.slice(0, 3) + '-' + inputValue.slice(3);
      }
      if (value.length > 7) {
        return;
      }

      let [org, dest] = value.split('-');
      fields = {
        org,
        dest
      };
      if (fields.org && fields.dest) {
        fields.org = fields.org.toUpperCase();
        fields.dest = fields.dest.toUpperCase();
      }
    }
    if (name === 'house_awb_no') {
      if (value.length > 3) {
        let inputValue = value.replace(/-/g, '');
        value = inputValue.slice(0, 3) + '-' + inputValue.slice(3);
      }
    }
    this.setState((prev) => ({
      houseAwbFields: {
        ...prev.houseAwbFields,
        ...fields,
        [name]: name === 'o_d' ? value?.toUpperCase() : value
      }
    }));
  };
  validateHouseAwb = () => {
    let errors = {};
    let isValid = true;
    if (!this.state.houseAwbFields.house_awb_no) {
      errors.house_awb_no = true;
      isValid = false;
    }
    if (!this.state.houseAwbFields.pcs) {
      errors.pcs = true;
      isValid = false;
    }
    if (!this.state.houseAwbFields.wgt) {
      errors.wgt = true;
      isValid = false;
    }
    if (!this.state.houseAwbFields.o_d) {
      errors.o_d = true;
      isValid = false;
    } else {
      let [org, dest] = this.state.houseAwbFields.o_d.split('-');
      if (!org || !dest) {
        errors.o_d = 'Invalid O-D';
        isValid = false;
      } else {
        if (org.length !== 3 || dest.length !== 3) {
          errors.o_d = 'Invalid O-D';
          isValid = false;
        }
      }
    }
    this.setState({ houseAwbErrors: errors });
    return isValid;
  };

  addHouseAwb = () => {
    if (!this.validateHouseAwb()) {
      return;
    }
    let house_awbs = [...this.state.modalData?.house_awbs || []];
    if (this.state.houseAwbFields.id) {
      let index = house_awbs.findIndex((house) => house.id === this.state.houseAwbFields.id);
      if (index !== -1)
        house_awbs[index] = this.state.houseAwbFields;
    } else {
      house_awbs.push(this.state.houseAwbFields);
    }
    this.setState({
      modalData: {
        ...this.state.modalData,
        house_awbs
      },
      houseAwbFields: {},
      houseAwbErrors: {}
    });
  };

  onEditHouseAwb = (house_awb) => {
    let house_awbs = [...this.state.modalData?.house_awbs || []];
    if (!house_awb.id) {
      let index = house_awbs.findIndex((house) => JSON.stringify(house) === JSON.stringify(house_awb));
      if (index !== -1)
        house_awbs.splice(index, 1);
    }
    this.setState({
      modalData: {
        ...this.state.modalData,
        house_awbs
      },
      houseAwbFields: {
        ...house_awb || {},
        o_d: house_awb.org + '-' + house_awb.dest
      },
      houseAwbErrors: {},
      editHouseAwb: true
    });
  };


  onDeleteHouseAwb = (row) => {
    console.log('onDeleteHouseAwb', row); //row.id
    let house_awbs = [...this.state.modalData?.house_awbs || []];
    if (row.id) {
      let index = house_awbs.findIndex((house) => house.id === row.id);
      if (index !== -1) {
        house_awbs[index].deleted = true;
        // house_awbs.splice(index, 1);
      }
    } else {
      let index = house_awbs.findIndex((house) => JSON.stringify(house) === JSON.stringify(row));
      if (index !== -1)
        house_awbs[index].deleted = true;
      // house_awbs.splice(index, 1);
    }
    console.log('house_awbs', house_awbs);
    this.setState({
      modalData: {
        ...this.state.modalData,
        house_awbs
      }
    }
    , () => {
      this.handlePopoverClose();
    }
    );
  };


  submitHouseAwb = (type = null) => {
    http.post('import_house_awb', {
      id: this.state.modalData.id,
      house_awbs: this.state.modalData.house_awbs
    }
    ).then(() => {
      this.setState({
        modal: type === 'add' ? 'add_house_awb' : false,
        anchorEl: null,
        modalData: type === 'add' ? this.state.modalData : false,
        editHouseAwb: false,
      });
    });
  };

  onStorage = (row, date) => {
    http.put('import_awb/storage/' + row.id, { storage_start: date });
  };

  handleNotification = (row) => {
    if (row.consigneeId) {
      let customData = { is_custom: row?.custom_status?.status?.length > 0 || row?.custom_status?.house_status?.filter((status) => status?.dispositionMsg?.length > 0).length > 0 };
      http.post('import_noti_awb', {
        awb_id: row.awbId,
        consignee_id: row.consigneeId,
        id: row.id
      }).then(({ data }) => {
        this.setState({
          modal: 'send_notification',
          modalData: {
            ...row,
            ...data.data,
            notifications: row.notifications || [],
            ...customData
          }
        });
      });
    }
  };

  handleSubmitNotification = async (e) => {
    e.preventDefault();
    let docs = [];
    if (e.target.docs) {
      if (e.target.docs.length === undefined) {
        if (e.target.docs.checked)
          docs.push(e.target.docs.value);
      } else {
        for (let i = 0; i < e.target.docs.length; i++) {
          console.log(e.target.docs[i]);
          if (e.target.docs[i].checked)
            docs.push(e.target.docs[i].value);
        }
      }
    }

    let notis = [];
    if (e.target.notis) {
      if (e.target.notis.length === undefined) {
        if (e.target.notis.checked)
          notis.push(e.target.notis.value);
      } else {
        for (let i = 0; i < e.target.notis.length; i++) {
          console.log(e.target.notis[i]);
          if (e.target.notis[i].checked)
            notis.push(e.target.notis[i].value);
        }
      }
    }

    let custom_file = null;
    if (e.target.custom_file && e.target.custom_file.checked) {
      custom_file = await this.downloadCustomStatusReport(this.state.modalData, true);
    }

    // Group emails into lines of 2
    const emails = this.state.modalData.mails.map(mail => mail.email);
    const groupedEmails = emails.reduce((acc, email, index) => {
      const lineIndex = Math.floor(index / 2);
      acc[lineIndex] = acc[lineIndex] ? acc[lineIndex] + ', ' + email : email;
      return acc;
    }, []);

    let station_mail = (cookies.get('stations') || []).find(stn => stn.code === cookies.get('station_code'))?.mail || '';

    let pdfContent =
      'From: ' + station_mail + '\n' +
      'Date: ' + moment().tz(timezone).format('MMMM D, YYYY [at] hh:mm:ss') + '\n' +
      'To: ' + groupedEmails.join('\n') + '\n' +
      'CC: ' + e.target.cc.value + '\n' +
      'BCC: ' + e.target.bcc.value + '\n' +
      'Subject: ' + e.target.subject.value + '\n\n' +
      '-------------------------\n\n' +
      e.target.pdf.value + '\n\n\n' +
      '-------------------------\n\n\n' +
      e.target.message_footer.value;

    let data = {
      id: this.state.modalData.id,
      flightId: this.state.modalData.flightId,
      awbId: this.state.modalData.awbId,
      consigneeId: this.state.modalData.consigneeId,
      mails: this.state.modalData.mails,
      cc: e.target.cc.value,
      bcc: e.target.bcc.value,
      subject: e.target.subject.value,
      message: e.target.message_body.value + '<br/> <br/>' + '<div><span style="font-weight: bold;color: #05164D;">' + e.target.message_footer.value + '</span></div>',
      pdf: pdfContent,
      docs,
      notis,
      pickupDate: getLocatDate(),
    };
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    if (custom_file) {
      formData.append('custom_file', custom_file, 'custom_status_report.pdf');
    }

    http.post('import_awb_notification', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
      this.handleClose();
    });
  };


  fetchDocs = (row) => {
    console.log('fetch Docs', row);
    let activeDoc = row?.notifications?.[row?.notifications.length - 1]?.id || null;
    if (row?.awbId || row?.house_awb) {
      let url = row?.house_awb ? 'doc_hawb/' + row.id : 'doc_awb/' + row.awbId;
      http.get(url).then(({ data }) => {
        console.log(data);
        this.handleTableCollapse(null);
        if (data.data.length > 0) {
          this.setState({
            activeAWB: row,
            docList: data.data,
            viewPreview: '',
          }, () => {
            this.selectDoc(null, data
              .data[0] ? data.data[0] : null);
          });
        } else {
          this.setState({
            activeAWB: row,
            docList: [],
            activeDoc: null,
            viewPreview: '',
          }, () => {
            if (activeDoc) this.selectDoc(null, { id: 'n' + activeDoc });
          });
        }
      });
    } else {
      this.setState({
        activeAWB: row,
        docList: [],
        activeDoc: null,
        viewPreview: '',
      }, () => {
        if (activeDoc) this.selectDoc(null, { id: 'n' + activeDoc });
      });
    }
  };

  onChangeFilter = (e) => {
    let { name, value } = e.target;
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }
    this.setState((prev) => ({
      filter: {
        ...prev.filter,
        [name]: value,
        // When Bounced Notifications is selected
        ...(name === 'bouncedNotifications' && value ? {
          customsCleared: false,
          noCustomsClearance: false,
        } : {}),
        // When Total radio is selected
        ...(name === 'awbType'
          ? {
            customsCleared: value === 'total',
            noCustomsClearance: value === 'total',
          }
          : {}),
      }
    }), () => {
      this.filterImportNotification();
    });
  };

  onChangeSearch = (e) => {
    const { name, value, type, checked } = e.target;
    let data = {};
    if (name === 'start_date' || name === 'end_date' || name === 'airline' || name === 'search_click') {
      if (name == 'end_date') {
        let start_date = this.state.searchFilters?.start_date;
        let end_date = value;
        if (start_date && end_date && start_date > end_date) {
          data.start_date = end_date;
        }
      }
      if (name == 'start_date') {
        let start_date = value;
        let end_date = this.state.searchFilters?.end_date;
        if (start_date && end_date && start_date > end_date) {
          data.end_date = start_date;
        }
      }
      this.setState((prev) => ({
        searchFilters: {
          ...prev.searchFilters,
          [name]: value,
          ...data
        }
      }), () => {
        if (name === 'airline') {
          this.filterImportNotification();
        }
        else {
          this.fetchImportNotification();
        }
      });
    } else if (name === 'noCustomsClearance') {
      this.setState((prev) => ({
        searchFilters: {
          ...prev.searchFilters,
          noCustomsClearance: type === 'checkbox' ? checked : value
        }
      }), () => {
        this.filterImportNotification();
      });
    } else {
      let formattedValue = value;
      if (name === 'flight_no') {
        const rawValue = (value || '').replace(/-/g, '');
        formattedValue = rawValue.length > 3
          ? `${rawValue.slice(0, 3)}-${rawValue.slice(3)}`
          : rawValue;
      }
      this.setState({ search: formattedValue });
    }
  };

  onResetFilters = () => {
    this.setState({ searchFilters: {}, }, () => {
      this.fetchImportNotification();
    });
  };

  selectDoc = (e, row) => {
    let item = this.state.docList.find((doc) => {
      return 'n' + doc.id == ('n' + e?.target.value) ? e?.target.value : row.id;
    });
    if (!item) {
      item = this.state.activeAWB?.notifications?.find((noti) => 'n' + noti.id == e?.target?.value ? e.target.value : row.id);
    }
    let activeDoc = e?.target?.value ? e.target.value : row.id;
    this.setState({
      activeDoc: activeDoc,
      viewPreview: item?.src
    });
  };

  downloadDoc = () => {
    const link = document.createElement('a');
    link.href = environment.apiService + 'document?key=' + this.state.viewPreview;
    link.download = 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  validateDoc = () => {
    const docFields = { ...this.state.docFields };
    const error = {};
    let formValid = true;
    if (!docFields.name || (docFields.name.trim().length === 0)) {
      formValid = false;
      error.name = true;
    }
    if (!docFields.file) {
      formValid = false;
      error.remark = 'Please select file.';
    }
    // if (docFields.file && docFields.file.size > 1000000) {
    //   formValid = false;
    //   error.remark = 'File size cannot be more than 1mb';
    // }
    this.setState({ docErrors: error });
    return formValid;
  };

  onChangeDoc = (e) => {
    let value = e.target.value;
    this.setState({
      docFields: {
        ...this.state.docFields,
        [e.target.name]: e.target.name == 'file' ? e.target.files[0] : value
      }
    });
  };

  onhandleChange = (e) => {
    let state = {};
    if (e.target.name == 'fileType') {
      if (e.target.value == 'third') {
        state['docFields'] = {
          name: '',
          type: 'AWB',
          contact_type: 'sms',
        };
      }
    } else {
      state['docFields'] = {};
    }
    state['docErrors'] = {};
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value,
      ...state
    });
  };

  addDoc = (e) => {
    console.log('addDoc', e);
    e.preventDefault();
    if (this.validateDoc()) {
      const formData = new FormData();
      formData.append('importawb_id', this.state.activeAWB.id);
      formData.append('awb_id', this.state.activeAWB.awbId);
      formData.append('type', this.state.addDocType);
      formData.append('attach_to', this.state.attachTo);
      formData.append('verifiedUserId', cookies.get('user'));
      formData.append('flightId', this.state.activeAWB.flightId);
      formData.append('row', JSON.stringify(this.state.activeAWB));
      formData.append('house_awb_no', this.state.activeAWB?.house_awb_no || '');
      formData.append('pcs', this.state.activeAWB?.pcs || '');
      formData.append('wgt', this.state.activeAWB?.wgt || '');
      formData.append('org', this.state.activeAWB?.org || '');
      formData.append('dest', this.state.activeAWB?.dest || '');
      Object.keys(this.state.docFields).forEach(key => {
        formData.append(key, this.state.docFields[key]);
      });
      let url = this.state.activeAWB?.house_awb ? 'doc_hawb/add' : 'doc_awb/add';
      http.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            docFields: {},
            docFieldsErrors: {},
          });
        }
      });
    }
  };

  updateColumnWidth = () => {
    let columnWidth = {};
    for (let key in this.columnRef) {
      if (this.columnRef[key].current) {
        columnWidth[key] = this.columnRef[key].current.offsetWidth;
      }
    }
    if (JSON.stringify(this.state.columnWidth) !== JSON.stringify(columnWidth)) {
      this.setState({ columnWidth: columnWidth });
    }
  };
  openConsigneeModal = (e, row) => {
    console.log('row?.consignee', row);
    e.preventDefault();
    console.log('row.awb.consignee', row);
    const phoneStr = row?.consignee?.phone || '';
    if (phoneStr && phoneStr.includes('+')) {
      const regex = /^(\+?\d{1,4})(\d{10,})$/;
      const match = phoneStr.match(regex);
      const phone_code = match?.[1] || '+1';
      const phone_number = match?.[2] || '';
      row = {
        ...row,
        consignee: {
          ...row.consignee,
          phone_code,
          phone_number,
        },
      };
    }
    this.setState({
      modal: 'update_consignee',
      consigneeSearch: row?.consigneeId ? row?.consignee?.name : row?.awb?.consignee || '',
      consigneeAddress: row?.awb?.consignee_address || '',
      selectedConsignee: row?.consignee || null,
      consigneeFields: row?.consignee ? cloneDeep(row?.consignee) : {},
      consigneRow: row,
    }, () => {
      this.fetchConsignee();
    });
  };

  fetchConsignee = () => {
    const requestTimestamp = Date.now();
    this.setState({ lastConsigneeRequest: requestTimestamp });

    if (this.state.consigneeSearch === '') {
      this.setState({ consignees: [] });
    } else {
      http.get('consignee?search=' + this.state.consigneeSearch, { headers: { hideloader: true } })
        .then((res) => {
          if (this.state.lastConsigneeRequest === requestTimestamp) {
            if (res.data) {
              this.setState({ consignees: res.data?.data || [] });
            }
          } else {
            console.log('delayed response...');
          }
        });
    }
  };

  onSelectedConsignee = (e) => {
    console.log('onSelectedConsignee', e.target.value);
    let selectedConsignee = this.state.consignees.find((consignee) => consignee.id == e.target.value);
    console.log('selectedConsignee', selectedConsignee);
    const phoneStr = selectedConsignee?.phone || '';
    if (phoneStr && phoneStr.includes('+')) {
      const regex = /^(\+?\d{1,4})(\d{10,})$/;
      const match = phoneStr.match(regex);
      const phone_code = match?.[1] || '+1';
      const phone_number = match?.[2] || '';
      selectedConsignee = {
        ...selectedConsignee,
        phone_code,
        phone_number,
      };
    }
    this.setState({
      selectedConsignee,
      consigneeFields: cloneDeep(selectedConsignee),
      consigneeOperation: 'disabled'
    });
  };

  addNewButtonHandler = () => {
    // clear consignee fields
    this.setState({
      consigneeFields: {
        name: this.state.consigneeSearch || '',
        address: this.state.consigneeAddress || '',
        address2: '',
        state: '',
        city: '',
        zip: '',
        email: '',
        phone_code: '+1',
        phone_number: '',
        phone: '',
        mails: [],
      },
      selectedConsignee: null,
      consigneeOperation: 'add'
    });
  };

  onConsigneeFieldsChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        [name]: value
      }
    });
  };

  onConsigneeMailChange = (e, index) => {
    console.log('onConsigneeMailChange', e.target.value, index);

    // this.setState({
    //   consigneeFields: {
    //     ...this.state.consigneeFields,
    //     mails
    //   }
    // });
    //this.state.consigneeFields.mails[index].email = e.target.value
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        mails: this.state.consigneeFields.mails.map((mail, i) => {
          if (i === index) {
            return {
              ...mail,
              email: e.target.value
            };
          }
          return mail;
        })
      }

    });

  };

  onAddCMail = () => {
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        mails: [...this.state.consigneeFields.mails || [], {
          companyId: null,
          stationId: null,
          consigneeId: this.state.consigneeFields.id,
          deleted: false,
          email: '',
          failed: false,
          id: null
        }]
      }
    });
  };
  onDeleteCMail = (index) => {
    let mails = [...this.state.consigneeFields.mails];
    mails[index].deleted = true;
    this.setState({
      consigneeFields: {
        ...this.state.consigneeFields,
        mails,
      },
    });
  };

  addConsignee = (e) => {
    e.preventDefault();
    if (this.validateConsignee()) {
      let phone_code = this.state.consigneeFields?.phone_code || '+1';
      let phone_number = this.state.consigneeFields?.phone_number || '';
      http.post('consignee', {
        ...this.state.consigneeFields,
        phone: phone_code + phone_number,
        phone_code,
        existing: [],
        exist: true
      }).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            selectedConsignee: data.data
          }, () => {
            this.assignConsignee();
          });
        } else {
          console.log(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  };

  updateConsignee = (e) => {
    e.preventDefault();
    if (this.validateConsignee()) {
      let phone = this.state.consigneeFields?.phone;
      let phone_code = '+1';
      let phone_number = '';
      let phonearr = phone.match(/^(\+?(\d{1,4}))(\d{10,})$/);
      if (phonearr) {
        phone_code = phonearr?.[1] || '+1';
        phone_number = phonearr?.[3];
      }
      http.put('consignee/' + this.state.consigneeFields.id, {
        ...this.state.consigneeFields,
        phone: phone_code + phone_number,
        phone_code
      }).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({ modal: false }, () => {
            this.assignConsignee();
          });
        }
      });
    }
  };

  editConsignee = (consigneeOperation) => {
    this.setState({ consigneeOperation });
  };

  onConsigneeSearch = (e) => {
    // clearTimeout(this.consigneeSearchTimer);
    const value = e.target.value;
    this.setState({ consigneeSearch: value }, () => {
      this.fetchConsignee();
      // this.consigneeSearchTimer = setTimeout(() => {
      //   this.fetchConsignee();
      // }, 0);
    });
  };

  validateConsignee = () => {
    const consigneeFields = { ...this.state.consigneeFields };
    const error = {};
    let formValid = true;
    if (!consigneeFields.name || (consigneeFields.name.trim().length === 0)) {
      formValid = false;
      error.name = true;
    }
    // if (!consigneeFields.contactName || (consigneeFields.contactName.trim().length === 0)) {
    //   formValid = false;
    //   error.contactName = true;
    // }
    // if (!consigneeFields.address || (consigneeFields.address.trim().length === 0)) {
    //   formValid = false;
    //   error.address = true;
    // }
    // if (!consigneeFields.state || (consigneeFields.state.trim().length === 0)) {
    //   formValid = false;
    //   error.state = true;
    // }
    // if (!consigneeFields.city || (consigneeFields.city.trim().length === 0)) {
    //   formValid = false;
    //   error.city = true;
    // }
    // if (!consigneeFields.zip || (consigneeFields.zip.trim().length === 0)) {
    //   formValid = false;
    //   error.zip = true;
    // }
    if (!consigneeFields.email) {
      error.email = true;
      formValid = false;
    }
    if (consigneeFields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(consigneeFields.email)) {
      error.email = 'Enter valid email address';
      formValid = false;
    }
    this.setState({ consigneeFieldsErrors: error });
    return formValid;
  };

  handleassignConsignee = (e, action) => {
    console.log('handleassignConsignee', e, action);
    console.log('this.state.activeDoc', this.state.activeDoc);
    console.log('activeAWB', this.state.activeAWB);
    //if action === 'Assign' call assignConsignee
    if (action === 'Assign') {
      this.assignConsignee();
    }
    //else if action === 'Add' call addConsignee
    else if (action === 'Add') {
      this.addConsignee(e);
    }
    //else if action === 'Update' call updateConsignee
    else if (action === 'Update') {
      this.updateConsignee(e);
    }
    //else do nothing
  };

  assignConsignee = () => {
    //code to assign consignee to awb
    let formdata = {
      consigneeId: this.state.selectedConsignee.id,
      flightId: this.state.activeAWB.flightId,
      parentAwbid: this.state.activeAWB.id,
    };
    if (this.validateConsignee()) {
      http.put('assign_consingnee/' + this.state.consigneRow?.id, formdata).then(() => {
        this.handleClose();
      });
    }
  };

  handleTableCollapse = (id = null) => {
    let collapseViewer = this.state.collapseViewer || [];
    if (!id) {
      collapseViewer = [];
    }
    if (collapseViewer?.includes(id)) {
      collapseViewer = collapseViewer.filter(item => item === id);
      const index = collapseViewer?.indexOf(id);
      if (index > -1) {
        collapseViewer?.splice(index, 1);
      }
    } else {
      collapseViewer.push(id);
    }
    this.setState({ collapseViewer });
  };

  handleCustomStatus = (id) => {
    if (id) {
      http.get('customs_city/request/' + id);
    } else if (this.props.flightTab) {
      http.get('customs_city/request?flight_id=' + this.props.flight?.id);
    } else {
      let importIds = this.state.importAwbs.map(item => item.id);
      http.get('customs_city/request?import_ids=' + importIds.join(','));
    }
  };

  handleNFDStatus = (id) => {
    if (id) {
      http.get('import_nfd?id=' + id);
    } else if (this.props.flightTab) {
      this.setState({ nfdProcessing: true });
      http.get('import_nfd?flightId=' + this.props.flight?.id, { headers: { 'hideloader': true } }).then(() => {
        this.setState({ nfdProcessing: false });
      }).catch(() => {
        this.setState({ nfdProcessing: false });
      });
    }
    else {
      let importIds = this.state.importAwbs.map(item => item.id);
      http.get('import_nfd?ids=' + importIds.join(','));
    }
  };

  fetchCustomStatusCodes = () => {
    http.get('settings?key=custom_status_codes').then(({ data }) => {
      if (data.data) {
        let status_codes = data.data?.find((item) => item.key === 'custom_status_codes');
        if (status_codes) {
          this.setState({ customStatusCodes: status_codes.value || [] });
        }
      }
    });
  };

  downloadCustomStatusReport = async (row, raw = false) => {
    const statusItems = row?.custom_status?.status || [];
    const house_status = row?.custom_status?.house_status || [];

    const statusRows = [
      ...statusItems.map((item) => ({
        masterAwb: row?.awb_no || '-',
        houseAwb: '-',
        dispositionCode: item?.dispositionCode || '-',
        dispositionActionDate: item?.dispositionActionDate || null,
        dispositionActionTime: item?.dispositionActionTime || null,
        name: item?.name || '-',
        description: item?.description || '',
        sortTimestamp: moment(`${item?.dispositionActionDate || ''}${item?.dispositionActionTime || ''}`, 'MMDDYYHHmmss', true).valueOf(),
      })),
      ...house_status.flatMap((item) => {
        const dispositionMsgs = item?.dispositionMsg || [];
        if (dispositionMsgs.length > 0) {
          return dispositionMsgs.map((msg) => ({
            masterAwb: row?.awb_no || '-',
            houseAwb: item?.hawbNumber || '-',
            dispositionCode: msg?.dispositionCode || '-',
            dispositionActionDate: msg?.dispositionActionDate || null,
            dispositionActionTime: msg?.dispositionActionTime || null,
            name: msg?.name || '-',
            description: msg?.description || '',
            sortTimestamp: moment(`${msg?.dispositionActionDate || ''}${msg?.dispositionActionTime || ''}`, 'MMDDYYHHmmss', true).valueOf(),
          }));
        }

        return [{
          masterAwb: row?.awb_no || '-',
          houseAwb: item?.hawbNumber || '-',
          dispositionCode: '-',
          dispositionActionDate: '-',
          dispositionActionTime: '-',
          name: '-',
          description: '-',
          sortTimestamp: '-',
        }];
      }),
    ].sort((a, b) => a.sortTimestamp - b.sortTimestamp);

    const primaryBlue = '#05164D';

    const styles = StyleSheet.create({
      page: {
        fontSize: 11,
        paddingTop: 30,
        paddingLeft: 60,
        paddingRight: 60,
        lineHeight: 1.5,
        flexDirection: 'column',
        paddingBottom: 65,
        paddingHorizontal: 35,
      },
      title: {
        fontSize: 12,
        marginBottom: 4,
        fontWeight: 700,
      },
      subtitle: {
        fontSize: 10,
        color: '#4b5563',
        marginBottom: 12,
      },
      metaRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 14,
      },
      metaText: { fontSize: 10, },
      table: {
        borderWidth: 1,
        borderColor: '#d1d5db',
      },
      tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f3f4f6',
        borderBottomWidth: 1,
        borderBottomColor: '#d1d5db',
      },
      tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
      },
      cellCode: {
        width: '16%',
        padding: 6,
      },
      cellCustomCode: {
        width: '10%',
        padding: 6,
      },
      cellDate: {
        width: '16%',
        padding: 6,
      },
      cellTime: {
        width: '16%',
        padding: 6,
      },
      cellStatus: {
        width: '42%',
        padding: 6,
      },
      headerText: {
        fontSize: 9,
        fontWeight: 600,
      },
      bodyText: {
        fontSize: 9,
        lineHeight: 1.4,
      },
      emptyState: { padding: 10, },
      emptyText: {
        fontSize: 10,
        color: '#6b7280',
      },
      titleContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '-30px -35px 30px -35px',
        padding: '10px 0 10px 35px',
        color: primaryBlue,
        borderBottom: `1px solid ${primaryBlue}`,
        backgroundColor: primaryBlue,
      },
      titleContent: {
        alignItems: 'flex-start',
        textAlign: 'left',
        backgroundColor: primaryBlue,
        color: 'white',
      },
      date: { fontSize: 10, },
      awb: { fontSize: 12, },
      reportLabel: {
        fontSize: 14,
        textTransform: 'uppercase',
        lineHeight: 'normal',
        paddingBottom: 2,
        fontFamily: 'NunitoRegular',
      },
      column: { flexDirection: 'column', },
      row: { flexDirection: 'row', },
      alignItemsCenter: { alignItems: 'center' },
      textNoWrap: { whiteSpace: 'nowrap', }

    });

    const doc = (
      <Document>
        <Page style={styles.page}>
          <View style={[styles.titleContainer]}>
            <View style={[styles.column, styles.titleContent]}>
              <View style={[styles.row, styles.alignItemsCenter]}>
                <Text style={styles.reportLabel}>{`Customs Status Report - ${row?.awb_no || '-'}`}</Text>
              </View>
              <Text style={styles.date}>{timezone ? moment().tz(timezone).format('DDMMMYYYY')?.toUpperCase() : null} | {cookies.get('station_code')}</Text>
            </View>
          </View>

          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <View style={styles.cellCode}><Text style={styles.headerText}>AWB</Text></View>
              <View style={styles.cellCode}><Text style={styles.headerText}>House AWB</Text></View>
              <View style={styles.cellCustomCode}><Text style={styles.headerText}>Code</Text></View>
              <View style={styles.cellDate}><Text style={styles.headerText}>Date</Text></View>
              <View style={styles.cellTime}><Text style={styles.headerText}>Time</Text></View>
              <View style={styles.cellStatus}><Text style={styles.headerText}>Status</Text></View>
            </View>

            {statusRows.length > 0 && (
              statusRows.map((item, index) => (
                <View key={'status-row-' + index} style={styles.tableRow}>
                  <View style={styles.cellCode}><Text style={styles.bodyText}>{item.masterAwb}</Text></View>
                  <View style={styles.cellCode}><Text style={[styles.bodyText, styles.textNoWrap]}>{item.houseAwb}</Text></View>
                  <View style={styles.cellCustomCode}><Text style={styles.bodyText}>{item.dispositionCode}</Text></View>
                  <View style={styles.cellDate}><Text style={styles.bodyText}>{item.dispositionActionDate && moment(item.dispositionActionDate, 'MMDDYY', true).isValid() ? moment(item.dispositionActionDate, 'MMDDYY').format(DateFormat).toUpperCase() : '-'}</Text></View>
                  <View style={styles.cellTime}><Text style={styles.bodyText}>{item.dispositionActionTime && moment(item.dispositionActionTime, 'HHmmss', true).isValid() ? moment(item.dispositionActionTime, 'HHmmss').format('HH:mm:ss') : (item.dispositionActionTime || '-')}</Text></View>
                  <View style={styles.cellStatus}>
                    <Text style={styles.bodyText}>{item.name || '-'}</Text>
                    {item.description ? <Text style={styles.bodyText}>{item.description}</Text> : null}
                  </View>
                </View>
              ))
            )}

            {statusRows.length === 0 && (
              <View style={styles.emptyState}>
                <Text style={styles.emptyText}>No customs status records available.</Text>
              </View>
            )}
          </View>
        </Page>
      </Document>
    );

    const asPdf = pdf();
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();
    if (raw) {
      return blob;
    }
    const link = document.createElement('a');
    const blobUrl = URL.createObjectURL(blob);
    link.href = blobUrl;
    link.download = 'Customs-Status-Report_' + row.awb_no + '.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };


  render() {
    return (
      <>
        <ImportNotification
          airlines={this.state.airlineList}
          showReportModal={this.props.showReportModal}
          downloadCustomStatusReport={this.downloadCustomStatusReport}
          handleCustomStatus={this.handleCustomStatus}
          search={this.state.search}
          searchFilters={this.state.searchFilters}
          onChangeSearch={this.onChangeSearch}
          filter={this.state.filter}
          onChangeFilter={this.onChangeFilter}
          flightTab={this.props.flightTab}
          importAwbs={this.state.filteredImportAwbs}
          allImportAwbs={this.state.importAwbs}
          modal={this.state.modal}
          modalData={this.state.modalData}
          anchorEl={this.state.anchorEl}
          onStorage={this.onStorage}
          handleOpen={this.handleOpen}
          handleClose={this.handleClose}
          handleChange={this.handleChange}
          serviceFields={this.state.serviceFields}
          serviceErrors={this.state.serviceErrors}
          submitHouseAwb={this.submitHouseAwb}
          zoomIn={this.zoomIn}
          zoomOut={this.zoomOut}
          scale={this.state.scale}
          partNotification={this.partNotification}
          onChangeHouseAwb={this.onChangeHouseAwb}
          onEditHouseAwb={this.onEditHouseAwb}
          onDeleteHouseAwb={this.onDeleteHouseAwb}
          houseAwbFields={this.state.houseAwbFields}
          houseAwbErrors={this.state.houseAwbErrors}
          addHouseAwb={this.addHouseAwb}
          handleNotification={this.handleNotification}
          handleSubmitNotification={this.handleSubmitNotification}
          services={this.state.services}
          additionalServices={this.state.additionalServices}
          handleChanegOperation={this.handleChanegOperation}
          onSubmitService={this.onSubmitService}
          onDeleteService={this.onDeleteService}
          fetchDocs={this.fetchDocs}
          activeAWB={this.state.activeAWB}
          docList={this.state.docList}
          activeDoc={this.state.activeDoc}
          selectDoc={this.selectDoc}
          downloadDoc={this.downloadDoc}
          viewPreview={this.state.viewPreview}
          docErrors={this.state.docErrors}
          addDoc={this.addDoc}
          onhandleChange={this.onhandleChange}
          addDocType={this.state.addDocType}
          attachTo={this.state.attachTo}
          docfields={this.state.docFields}
          onChangeDoc={this.onChangeDoc}
          columnWidth={this.state.columnWidth}
          columnRef={this.columnRef}
          openConsigneeModal={this.openConsigneeModal}
          consignees={this.state.consignees}
          consigneeFields={this.state.consigneeFields}
          consigneeFieldsErrors={this.state.consigneeFieldsErrors}
          addNewButtonHandler={this.addNewButtonHandler}
          onSelectedConsignee={this.onSelectedConsignee}
          selectedConsignee={this.state.selectedConsignee}
          consigneeOperation={this.state.consigneeOperation}
          consigneeSearch={this.state.consigneeSearch}
          onConsigneeSearch={this.onConsigneeSearch}
          handleassignConsignee={this.handleassignConsignee}
          editConsignee={this.editConsignee}
          onConsigneeFieldsChange={this.onConsigneeFieldsChange}
          onAddCMail={this.onAddCMail}
          onDeleteCMail={this.onDeleteCMail}
          onConsigneeMailChange={this.onConsigneeMailChange}
          handleTableCollapse={this.handleTableCollapse}
          collapseViewer={this.state.collapseViewer}
          handlePopoverOpen={this.handlePopoverOpen}
          handlePopoverClose={this.handlePopoverClose}
          popover={this.state.popover}
          popoverAnchorEl={this.state.popoverAnchorEl}
          popoverData={this.state.popoverData}
          editHouseAwb={this.state.editHouseAwb}
          showRejectedMessage={this.props.showRejectedMessage}
          showNilMessage={this.props.showNilMessage}
          handleDeleteConsignee={this.handleDeleteConsignee}
          cron={this.state.cron}
          cron_period={this.state.cron_period}
          cron_code={this.state.cron_code}
          nfdProcessing={this.state.nfdProcessing}
          handleNFDStatus={this.handleNFDStatus}
          customStatusCodes={this.state.customStatusCodes}
          onResetFilters={this.onResetFilters}
          customStatus={this.state.customStatus}
          scraper={this.state.scraper}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { flight: state.flight, };
};

export default connect(mapStateToProps, null)(ImportNotificationContainer);
